import { render, staticRenderFns } from "./WithholdingsPending.vue?vue&type=template&id=cd6c1c18"
import script from "./WithholdingsPending.vue?vue&type=script&lang=js"
export * from "./WithholdingsPending.vue?vue&type=script&lang=js"
import style0 from "./WithholdingsPending.vue?vue&type=style&index=0&id=cd6c1c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports